export const getBusinessInsightsUrl = () => '/agency/business_insights';
